import { ErrorHandler, Injectable } from '@angular/core';
 
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error('Global Error:', error);
    // Handle chunk load failure
    if (
      error?.message?.includes('Failed to fetch dynamically imported module') ||
      error?.message?.includes('ChunkLoadError')
    ) {
      console.warn('Chunk load failed → reloading app');
      location.reload();
      return;
    }
    // fallback
    console.error(error);
  }
}